// extracted by mini-css-extract-plugin
export default {"root":"classes_root__iu8J0","pointer":"classes_pointer__xwhEU"};